import { createBucketClient } from "@cosmicjs/sdk";

const cosmic = createBucketClient({
	bucketSlug: "g-factory-production",
	readKey: "lDN2lVYkFqu4gpsGZrM2z8jjak8n611qo5hU5e8SFbSo2VYtwC",
});


export default cosmic;